import {
  PageChangePassword,
  PageClinic,
  PageCouponFamily,
  PageCreateAdmin,
  PageCreateClient,
  PageCreateClinic,
  PageCreateCouponFamily,
  PageCreateHealthRecord,
  PageCreatePassword,
  PageCreateRecord,
  PageError404,
  PageForgotPassword,
  PageGenerateCoupon,
  PageHealthClient,
  PageHealthRecords,
  PageHome,
  PageListAdmin,
  PageListClients,
  PageListCoupon,
  PageLogin,
  PageOtp,
  PagePatient,
  PagePhoneLogin,
  PagePrivacy,
  PageProfile,
  PageRecords,
  PageRedeemCoupon,
  PageRedeemList,
  PageSignup,
  PageTerms,
  PageProduct,
  PageCreateProduct,
  PageInventory,
  PageCreateInventory,
  PageSale,
  PageSaleOrder,
  PageCdicRedeemList,
  PageListCdicClients,
  PageCreateCdicClient,
  PageListCdicCoupon,
  PageGenerateCdicCoupon,
  PageRedeemCdicCoupon,
} from "@pages";
import { PageCreateCdicProgram } from "@pages/coupon/Program";
import { PageProgramList } from "@pages/coupon/ProgramList";
import { PageCreateCdicService } from "@pages/coupon/Service";
import { IRoute } from "@interfaces";
import { AppLayout, AuthLayout, LayoutError } from "@layouts";
import {
  PATH_ADD_ADMIN,
  PATH_ADD_CLINIC,
  PATH_ADMINS,
  PATH_CDIC_CLIENT_INFO,
  PATH_CDIC_COUPON_LIST,
  PATH_CDIC_COUPON_REDEEM,
  PATH_CDIC_PATIENT,
  PATH_CHANGE_PASSWORD,
  PATH_CLIENT_CREATE,
  PATH_CLIENT_INFO,
  PATH_CLINIC,
  PATH_COUPON_FAMILY,
  PATH_COUPON_LIST,
  PATH_COUPON_REDEEM,
  PATH_CREATE_CDIC_CLIENT,
  PATH_CREATE_CDIC_PROGRAM,
  PATH_CREATE_COUPON_FAMILY,
  PATH_CREATE_DEPO_RECORDS,
  PATH_CREATE_ORDER,
  PATH_CREATE_PASSWORD,
  PATH_CREATE_SERVICE_NAME,
  PATH_DEPO_RECORDS,
  PATH_FORGOT_PASSWORD,
  PATH_GENERATE_CDIC_COUPON,
  PATH_GENERATE_COUPON,
  PATH_HEALTH_RECORDS,
  PATH_HEALTH_RECORDS_CREATE,
  PATH_HOME,
  PATH_INVENTORY_CREATE,
  PATH_INVENTORY_MASTER,
  PATH_LOGIN,
  PATH_LOGIN_BY_PHONE,
  PATH_MY_PROFILE,
  PATH_OTP,
  PATH_PATIENT,
  PATH_PRIVACY_POLICY,
  PATH_PRODUCT_CREATE,
  PATH_PRODUCT_MASTER,
  PATH_REDEEM_CDIC_COUPON,
  PATH_REDEEM_COUPON,
  PATH_SALE_ORDER,
  PATH_SIGNUP,
  PATH_SRHR_PATIENT,
  PATH_TERMS_AND_CONDITIONS,
} from "./paths";

export const routes: Array<IRoute> = [
  { path: PATH_HOME, component: PageHome, exact: true, layout: AppLayout },
  { path: PATH_LOGIN, component: PageLogin, exact: true, layout: AuthLayout },
  { path: PATH_SIGNUP, component: PageSignup, exact: true, layout: AppLayout },
  { path: PATH_CDIC_CLIENT_INFO, component: PageListCdicClients, exact: true, layout: AppLayout },
  { path: PATH_CDIC_CLIENT_INFO + "/:id", component: PageCreateCdicClient, exact: true, layout: AppLayout },
  { path: PATH_CREATE_CDIC_CLIENT, component: PageCreateCdicClient, exact: true, layout: AppLayout },
  { path: PATH_CLIENT_INFO, component: PageListClients, exact: true, layout: AppLayout },
  { path: PATH_CLIENT_INFO + "/:id", component: PageCreateClient, exact: true, layout: AppLayout },
  { path: PATH_CLIENT_CREATE, component: PageCreateClient, exact: true, layout: AppLayout },
  { path: PATH_ADMINS, component: PageListAdmin, exact: true, layout: AppLayout },
  { path: PATH_ADMINS + "/:id", component: PageCreateAdmin, exact: true, layout: AppLayout },
  { path: PATH_ADD_ADMIN, component: PageCreateAdmin, exact: true, layout: AppLayout },
  { path: PATH_CLINIC, component: PageClinic, exact: true, layout: AppLayout },
  { path: PATH_CLINIC + "/:id", component: PageCreateClinic, exact: true, layout: AppLayout },
  { path: PATH_ADD_CLINIC, component: PageCreateClinic, exact: true, layout: AppLayout },
  { path: PATH_DEPO_RECORDS, component: PageRecords, exact: true, layout: AppLayout },
  { path: PATH_CREATE_DEPO_RECORDS, component: PageCreateRecord, exact: true, layout: AppLayout },
  { path: PATH_DEPO_RECORDS + "/:id", component: PageCreateRecord, exact: true, layout: AppLayout },
  { path: PATH_HEALTH_RECORDS, component: PageHealthRecords, exact: true, layout: AppLayout },
  { path: PATH_HEALTH_RECORDS_CREATE, component: PageCreateHealthRecord, exact: true, layout: AppLayout },
  { path: PATH_HEALTH_RECORDS + "/:id", component: PageCreateHealthRecord, exact: true, layout: AppLayout },
  { path: PATH_SRHR_PATIENT, component: PageHealthClient, exact: true, layout: AppLayout },
  { path: PATH_PRODUCT_MASTER, component: PageProduct, exact: true, layout: AppLayout },
  { path: PATH_PRODUCT_MASTER + "/:id", component: PageCreateProduct, exact: true, layout: AppLayout },
  { path: PATH_PRODUCT_CREATE, component: PageCreateProduct, exact: true, layout: AppLayout },
  { path: PATH_INVENTORY_MASTER, component: PageInventory, exact: true, layout: AppLayout },
  { path: PATH_INVENTORY_CREATE, component: PageCreateInventory, exact: true, layout: AppLayout },
  { path: PATH_SALE_ORDER, component: PageSale, exact: true, layout: AppLayout },
  { path: PATH_CREATE_ORDER, component: PageSaleOrder, exact: true, layout: AppLayout },
  { path: PATH_COUPON_LIST, component: PageListCoupon, exact: true, layout: AppLayout },
  { path: PATH_CDIC_COUPON_LIST, component: PageProgramList, exact: true, layout: AppLayout },
  { path: PATH_CDIC_COUPON_LIST + "/:id", component: PageListCdicCoupon, exact: true, layout: AppLayout },
  { path: PATH_CREATE_CDIC_PROGRAM, component: PageCreateCdicProgram, exact: true, layout: AppLayout },
  { path: PATH_CREATE_SERVICE_NAME, component: PageCreateCdicService, exact: true, layout: AppLayout },
  { path: PATH_CREATE_COUPON_FAMILY, component: PageCreateCouponFamily, exact: true, layout: AppLayout },
  { path: PATH_GENERATE_COUPON, component: PageGenerateCoupon, exact: true, layout: AppLayout },
  { path: PATH_GENERATE_CDIC_COUPON, component: PageGenerateCdicCoupon, exact: true, layout: AppLayout },
  { path: PATH_COUPON_FAMILY + "/:id", component: PageCouponFamily, exact: true, layout: AppLayout },
  { path: PATH_COUPON_REDEEM, component: PageRedeemList, exact: true, layout: AppLayout },
  { path: PATH_CDIC_COUPON_REDEEM, component: PageCdicRedeemList, exact: true, layout: AppLayout },
  { path: PATH_REDEEM_COUPON, component: PageRedeemCoupon, exact: true, layout: AppLayout },
  { path: PATH_REDEEM_CDIC_COUPON, component: PageRedeemCdicCoupon, exact: true, layout: AppLayout },
  { path: PATH_PATIENT, component: PagePatient, exact: true, layout: AppLayout },
  { path: PATH_CDIC_PATIENT, component: PagePatient, exact: true, layout: AppLayout },
  { path: PATH_TERMS_AND_CONDITIONS, component: PageTerms, exact: true, layout: AppLayout },
  { path: PATH_PRIVACY_POLICY, component: PagePrivacy, exact: true, layout: AppLayout },
  { path: PATH_MY_PROFILE, component: PageProfile, exact: true, layout: AppLayout },
  { path: PATH_CREATE_PASSWORD, component: PageCreatePassword, exact: true, layout: AuthLayout },
  { path: PATH_CHANGE_PASSWORD, component: PageChangePassword, exact: true, layout: AuthLayout },
  { path: PATH_FORGOT_PASSWORD, component: PageForgotPassword, exact: true, layout: AuthLayout },
  { path: PATH_LOGIN_BY_PHONE, component: PagePhoneLogin, exact: true, layout: AuthLayout },
  { path: PATH_OTP, component: PageOtp, exact: true, layout: AuthLayout },
  { component: PageError404, exact: false, layout: LayoutError },
];
